import React from "react";
import { BsArrowRight } from 'react-icons/bs'

const styles = {
  moreArrowWrapper: `w-full flex items-center mt-5`,
  pTag: `text-secondary font-bold flex items-center cursor-pointer 2xl:text-xl`,
  arrowStyle: "text-2xl 2xl:text-3xl"
}

const MoreArrow = ({text}) => {
  return (
    <div className={styles.moreArrowWrapper}>
      <p className={styles.pTag}>
        {text}&nbsp;
        <span>
          <BsArrowRight className={styles.arrowStyle} />
        </span>
      </p>
    </div>
  );
};

export default MoreArrow;
